import v from "./index.es144.js";
import O from "./index.es354.js";
import h from "./index.es265.js";
import o from "./index.es155.js";
import C from "./index.es150.js";
import U from "./index.es355.js";
import q from "./index.es267.js";
import x from "./index.es158.js";
import { progressEventReducer as y } from "./index.es356.js";
import N from "./index.es357.js";
const k = typeof XMLHttpRequest < "u", X = k && function(s) {
  return new Promise(function(L, i) {
    const t = N(s);
    let c = t.data;
    const f = x.from(t.headers).normalize();
    let { responseType: l, onUploadProgress: E, onDownloadProgress: g } = t, a, T, R, d, p;
    function w() {
      d && d(), p && p(), t.cancelToken && t.cancelToken.unsubscribe(a), t.signal && t.signal.removeEventListener("abort", a);
    }
    let e = new XMLHttpRequest();
    e.open(t.method.toUpperCase(), t.url, !0), e.timeout = t.timeout;
    function b() {
      if (!e)
        return;
      const n = x.from(
        "getAllResponseHeaders" in e && e.getAllResponseHeaders()
      ), r = {
        data: !l || l === "text" || l === "json" ? e.responseText : e.response,
        status: e.status,
        statusText: e.statusText,
        headers: n,
        config: s,
        request: e
      };
      O(function(u) {
        L(u), w();
      }, function(u) {
        i(u), w();
      }, r), e = null;
    }
    "onloadend" in e ? e.onloadend = b : e.onreadystatechange = function() {
      !e || e.readyState !== 4 || e.status === 0 && !(e.responseURL && e.responseURL.indexOf("file:") === 0) || setTimeout(b);
    }, e.onabort = function() {
      e && (i(new o("Request aborted", o.ECONNABORTED, s, e)), e = null);
    }, e.onerror = function(n) {
      const r = n && n.message ? n.message : "Network Error", u = new o(r, o.ERR_NETWORK, s, e);
      u.event = n || null, i(u), e = null;
    }, e.ontimeout = function() {
      let n = t.timeout ? "timeout of " + t.timeout + "ms exceeded" : "timeout exceeded";
      const r = t.transitional || h;
      t.timeoutErrorMessage && (n = t.timeoutErrorMessage), i(new o(
        n,
        r.clarifyTimeoutError ? o.ETIMEDOUT : o.ECONNABORTED,
        s,
        e
      )), e = null;
    }, c === void 0 && f.setContentType(null), "setRequestHeader" in e && v.forEach(f.toJSON(), function(n, r) {
      e.setRequestHeader(r, n);
    }), v.isUndefined(t.withCredentials) || (e.withCredentials = !!t.withCredentials), l && l !== "json" && (e.responseType = t.responseType), g && ([R, p] = y(g, !0), e.addEventListener("progress", R)), E && e.upload && ([T, d] = y(E), e.upload.addEventListener("progress", T), e.upload.addEventListener("loadend", d)), (t.cancelToken || t.signal) && (a = (n) => {
      e && (i(!n || n.type ? new C(null, s, e) : n), e.abort(), e = null);
    }, t.cancelToken && t.cancelToken.subscribe(a), t.signal && (t.signal.aborted ? a() : t.signal.addEventListener("abort", a)));
    const m = U(t.url);
    if (m && q.protocols.indexOf(m) === -1) {
      i(new o("Unsupported protocol " + m + ":", o.ERR_BAD_REQUEST, s));
      return;
    }
    e.send(c || null);
  });
};
export {
  X as default
};
//# sourceMappingURL=index.es270.js.map
